export enum UrlStateEnum {
  HOME_PAGE = "Home",
  BEEM_SHOT = "Beem Shot",
  BEEM_PILOT = "Beem Pilot",
  PROJECTS = "Projets",
  GLOBAL_RSEE_DASHBOARD = "Dashboard RSEE Global",
  OPEE_ANALYSIS = "Analyse OPEE",
  TUTORIELS = "Tutoriels",
  MY_GAMMES = "Mes gammes",
  INIES_CHANGES = "Modifications INIES",
}
